exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-box[data-v-208fa61b] .el-button{margin:2px}.custom-span[data-v-208fa61b]{font-size:16px !important}.custom-scope span[data-v-208fa61b]{margin:10px !important}\n", ""]);

// exports
